/* eslint-disable react/forbid-component-props */
import { Grid, Typography, Box, ButtonBase, SxProps } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import {
	BenefitImgContainerSX,
	BenefitItemContentSX,
	BenefitItemDescriptionSX,
	BenefitItemTitleSX,
} from '@/components/blocks/Benefits/styles/item';
import { parseHTML } from '@/utils/parseHTML';

export const Benefit = ({
	title,
	description,
	imgSrc,
	isTablet,
	onClick,
}: {
	title: string;
	description: string;
	imgSrc: string;
	isTablet: boolean;
	onClick?: () => void;
	sx?: SxProps;
}) => (
	<Grid item className="benefit-item">
		<ButtonBase
			className="benefit-item-content"
			sx={BenefitItemContentSX(isTablet)}
			onClick={onClick}
		>
			<Box className="benefit-item-img-container" sx={BenefitImgContainerSX}>
				<Img className="benefit-item-img" src={imgSrc} height={'37.5px'} alt={title} />
			</Box>
			<Typography component="h3" className="benefit-item-title" sx={BenefitItemTitleSX(isTablet)}>
				{parseHTML(title)}
			</Typography>
			<Typography className="benefit-item-description" sx={BenefitItemDescriptionSX}>
				{parseHTML(description)}
			</Typography>
		</ButtonBase>
	</Grid>
);
